import { Portal } from '../../interfaces';
import {
  MonitoringCounter,
  MonitoringDataStore,
  MonitoringDuration,
  MonitoringMetaData
} from './monitoring-interfaces';
import * as Logger from '../../common/tools/logger';

let monitoringUrls: { [key:string]: string } = {};
try {
  monitoringUrls = JSON.parse('REPLACE:MONITORING_URL');
} catch (e) {
  // only for unit tests where placeholders are not replaced:
  monitoringUrls = {
    default: ''
  };
}


const hasBeacon = typeof navigator.sendBeacon === 'function';

export class MonitoringService {

  private data: MonitoringDataStore = {
    meta: {
      brand: null,
      section: null
    },
    counters: [],
    durations: []
  };

  protected initData(metaData: MonitoringMetaData): void {
    this.data = {
      meta: Object.assign({}, metaData),
      counters: [],
      durations: []
    }
  }

  setMetaData(metaData: MonitoringMetaData): void {
    this.data.meta = Object.assign({}, this.data.meta, metaData);
  }

  pushCounter(counter: MonitoringCounter | MonitoringCounter[]): void {
    if (!(counter instanceof Array)) {
      counter = [counter];
    }

    this.data.counters.push(...counter);
  }

  pushDuration(duration: MonitoringDuration | MonitoringDuration[]): void {
    if (!(duration instanceof Array)) {
      duration = [duration];
    }

    this.data.durations.push(...duration);
  }

  flush(): void {
    if (!hasBeacon || (this.data.counters.length === 0 && this.data.durations.length === 0)) {
      return;
    }

    try {
      const queued = navigator.sendBeacon(getMonitoringUrl(this.data.meta.brand), JSON.stringify(this.data));
      if (queued) {
        // beacon request is queued by the browser, flush our data queues
        this.initData(this.data.meta);
      } else {
        Logger.error('Monitoring beacon was not queued!');
      }
    } catch (e) {
      Logger.error('Error while sending monitoring beacon', e);
    }
  }

}

export function getMonitoringUrl(portal: Portal): string {
  return monitoringUrls[portal] || monitoringUrls.default;
}

export const monitoringService = new MonitoringService();
